import { memo } from 'react'

import { useMatchRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import {
  mediaPlatformSpacePermissionsRoute,
  mediaPlatformSpacePermissionsUsersOverviewRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Permissions'
import { mediaPlatformSpaceRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Routing'
import { mediaPlatformSpaceSharingOverviewRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Sharing'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages', 'entity'])
  const matchRoute = useMatchRoute()

  return (
    <Content
      HeaderSlot={
        <Header
          disabled
          title={t('entity:publishing.space', { count: 1 })}
          TabNavigation={
            <Tabs>
              <NavigationTabLink
                selected={
                  !!matchRoute({
                    to: mediaPlatformSpacePermissionsRoute.to,
                    fuzzy: true,
                  })
                }
                from={mediaPlatformSpaceRoute.fullPath}
                to={mediaPlatformSpacePermissionsUsersOverviewRoute.to}
              >
                {t('pages:MediaOTT.mediaPlatform.Spaces.permissions')}
              </NavigationTabLink>
              <NavigationTabLink from={mediaPlatformSpaceRoute.fullPath} to={mediaPlatformSpaceSharingOverviewRoute.to}>
                {t('pages:MediaOTT.mediaPlatform.Spaces.sharing')}
              </NavigationTabLink>
            </Tabs>
          }
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
